<template>
  <div v-if="personal && sensitive">
    <v-row
      class="status-banner"
      justify="center"
      no-gutters
      style="background-color: #087ef7;"
      ><v-col
        class="lighten-2 pt-15 pb-10 col-11"
        cols="7"
        sm="11"
        md="9"
        lg="7"
      >
        <p class="title white--text">
          {{ $t('개인정보 수집 및 이용에 대한 동의') }}
        </p>
      </v-col>
    </v-row>
    <v-row class="status-list" justify="center" no-gutters>
      <v-col class="pt-10 col-11" cols="7" sm="11" md="9" lg="7">
        <i-checkbox
          v-model="checkboxAll"
          label="모두 동의합니다."
          hide-details
          true-value="Y"
          false-value="N"
          @change="allcheck"
          class="mt-n1 main-title"
        ></i-checkbox>
        <div class="inner-wrap px-12 py-8" no-gutters v-if="personal">
          <div class="inner-wrap">
            <i-checkbox
              v-model="personalYn"
              label="개인정보 수집에 대한 동의(필수)"
              true-value="Y"
              false-value="N"
              hide-details
              class="mt-n2"
            ></i-checkbox>
            <!-- <ckeditor
              class="terms"
              style="border: 1px solid; margin-top: 10px;"
              :editor="editor"
              :config="editorConfig"
              @ready="editorInit"
              v-model="personal.privacyPolicy"
            ></ckeditor> -->
            <CommonCkEditor
              class="terms"
              :isReadOnly="true"
              v-model="personal.privacyPolicy"
            />
            <i-checkbox
              v-model="personalUseYn"
              label="개인정보 이용에 대한 동의(필수)"
              true-value="Y"
              false-value="N"
              hide-details
              class="mt-7"
            ></i-checkbox>
            <CommonCkEditor
              class="terms"
              :isReadOnly="true"
              v-model="personalUse.privacyPolicy"
            />
            <!-- <ckeditor
              class="terms"
              style="border: 1px solid; margin-top: 10px;"
              :editor="editor"
              :config="editorConfig"
              @ready="editorInit"
              v-model="personalUse.privacyPolicy"
            ></ckeditor> -->
            <i-checkbox
              v-model="sensitiveYn"
              label="민감정보 수집 및 이용에 대한 동의(필수)"
              true-value="Y"
              false-value="N"
              hide-details
              class="mt-7"
            ></i-checkbox>
            <!-- <ckeditor
              v-if="sensitive"
              style="border: 1px solid; margin-top: 10px;"
              class="terms"
              :editor="editor"
              :config="editorConfig"
              @ready="editorInit"
              v-model="sensitive.privacyPolicy"
            ></ckeditor> -->
            <CommonCkEditor
              v-if="sensitive"
              class="terms"
              :isReadOnly="true"
              v-model="sensitive.privacyPolicy"
            />

            <i-checkbox
              v-model="thirdPartyAgreeYn"
              label="개인정보 제3자 제공 동의(필수) "
              true-value="Y"
              false-value="N"
              hide-details
              class="mt-7"
            ></i-checkbox>
            <!-- <ckeditor
              v-if="thirdPartyAgree"
              style="border: 1px solid; margin-top: 10px;"
              class="terms"
              :editor="editor"
              :config="editorConfig"
              @ready="editorInit"
              v-model="thirdPartyAgree.privacyPolicy"
            ></ckeditor> -->
            <CommonCkEditor
              v-if="thirdPartyAgree"
              class="terms"
              :isReadOnly="true"
              v-model="thirdPartyAgree.privacyPolicy"
            />
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="status-list" justify="center" no-gutters white>
      <v-col class="lighten-2 pt-10 col-11" cols="7" sm="11" md="9" lg="7">
        <p class="main-title">{{ $t('채용 서류 반환에 대한 안내') }}</p>
        <div class="inner-wrap px-12 py-8">
          <div class="desc" v-if="recruit">
            {{
              $t(
                '채용 과정에서 일부 서류를 직접 제출 받은 경우, 제출된 서류 반환에\n 대해서는 아래내용 참고하여 주시기 바랍니다.',
              )
            }}
            <CommonCkEditor
              class="terms"
              :isReadOnly="true"
              v-model="recruit.privacyPolicy"
            ></CommonCkEditor>
            {{
              $t(
                '상기 내용은 채용절차의 공정화에 관한 법률 및 시행령에 의거하여 안내드립니다.',
              )
            }}
          </div>
          <div class="btn-wrap pt-12 text-center">
            <i-btn
              rounded
              elevation="0"
              outlined
              color="normal"
              @click="mypage()"
              class="cancel-btn"
            >
              {{ $t('지원서 작성 취소하기') }}</i-btn
            >
            <i-btn
              rounded
              elevation="0"
              type="submit"
              @click="save()"
              class="ml-2 next-btn"
              >{{ $t('다음단계') }}</i-btn
            >
          </div>
        </div>
        <v-divider class="mb-16"></v-divider>
      </v-col>
    </v-row>
  </div>
  <div v-else></div>
</template>

<script>
import { DialogMixin } from '@/mixin/dialog.js';
import { getAuthJson, postAuthJson } from '@/api/network';
// import vueCustomScrollbar from 'vue-custom-scrollbar';
// import 'vue-custom-scrollbar/dist/vueScrollbar.css';

import CommonCkEditor from '@/components/common/CommonCkEditor.vue';

export default {
  components: { CommonCkEditor },
  mixins: [DialogMixin],
  data() {
    return {
      personal: null,
      personalUse: null,
      sensitive: null,
      recruit: null,
      thirdPartyAgree: null,
      checkboxAll: 'N',
      personalYn: 'N',
      personalUseYn: 'N',
      sensitiveYn: 'N',
      recruitGuidYn: 'N',
      thirdPartyAgreeYn: 'N',
    };
  },
  mounted() {
    this.setting();
  },
  methods: {
    setting: function() {
      const p = { annoId: this.$route.params.annoId };
      getAuthJson('api/v1/' + this.$route.params.tenantKey + '/policy', p)
        .then(res => {
          if (res && res.data) {
            if (res.data.hasOwnProperty('personal'))
              this.personal = res.data.personal;

            if (res.data.hasOwnProperty('personalUse'))
              this.personalUse = res.data.personalUse;

            if (res.data.hasOwnProperty('sensitive'))
              this.sensitive = res.data.sensitive;

            if (res.data.hasOwnProperty('recruit'))
              this.recruit = res.data.recruit;

            if (res.data.hasOwnProperty('thirdPartyAgree'))
              this.thirdPartyAgree = res.data.thirdPartyAgree;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    editorInit(editor) {
      //READ-ONLY
      editor.isReadOnly = true;
      var element = editor.ui.view.toolbar.element;
      element.style.display = 'none';

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(element, editor.ui.getEditableElement());
    },
    allcheck: function() {
      this.personalYn = this.checkboxAll;
      this.personalUseYn = this.checkboxAll;
      this.sensitiveYn = this.checkboxAll;
      this.thirdPartyAgreeYn = this.checkboxAll;
    },
    mypage: function() {
      this.$router.push({ name: 'myPage' });
    },
    save: function() {
      if (
        this.personalYn === 'Y' &&
        this.personalUseYn === 'Y' &&
        this.sensitiveYn === 'Y' &&
        this.thirdPartyAgreeYn === 'Y'
      ) {
        const p = {
          annoId: this.$route.params.annoId,
          personalId: this.personal.privacyPolicyId,
          personalUseId: this.personalUse.privacyPolicyId,
          sensitiveId: this.sensitive.privacyPolicyId,
          thirdPartyAgreeId: this.thirdPartyAgree.privacyPolicyId,
        };

        postAuthJson('api/v1/' + this.$route.params.tenantKey + '/policy', p)
          .then(res => {
            if (res.status == 200) {
              location.reload();
            } else {
              this.$showAlert(
                '개인정보 수집 및 이용 약관과 제3자동의 민감정보 수집 및 이용에 관한 동의를 하는데 실패하였습니다.',
              );
            }
          })
          .catch(error => {
            console.log(error.response);
          });
      } else {
        this.$showAlert(
          '개인정보 수집 및 이용 약관과 제3자동의와 민감정보 수집 및 이용과 에 관한 사항에 모두 동의해주세요.',
        );
      }
    },
  },
};
</script>

<style>
/* status-banner */
.status-banner .title {
  font-size: 26px !important;
}
.status-list .main-title {
  padding-bottom: 20px;
  padding-left: 20px;
  border-bottom: 2px solid #3f3f3f;
  font-size: 20px;
  color: #333 !important;
}
.status-list .main-title .v-label {
  font-size: 20px !important;
  color: #333 !important;
}

.status-list .terms {
  /* overflow-x: hidden;
  overflow-y: scroll; */
  height: 200px;
  padding: 10px 12px;
  margin-top: 10px;
  border: 1px solid #ccc;
  font-size: 12px;
  line-height: 22px;
  background-color: #fff;
  color: gray;
}

.status-list .sub-title-wrap {
  position: relative;
  margin-top: -1px;
  background: #e9e9e9;
}
.status-list .sub-title-wrap + .sub-title-wrap {
  border-top: 1px solid #999999;
}
.status-list .sub-title-wrap .sub-title {
  font-size: 20px;
  color: #5695db;
}

.status-list .sub-list {
  list-style: none;
  /* padding-left: 16px; */
  /* padding: 10px 12px; */
}

.status-list .sub-list li::before {
  content: '- ';
}

.status-list .desc {
  font-size: 14px;
  line-height: 2;
  color: #333333 !important;
}
.status-list .desc .sub-list li {
  color: #666666 !important;
}
.status-list .desc .sub-list li::before {
  padding-right: 4px;
  margin-left: -12px;
}

/* .status-list .v-input--selection-controls__input {
  display: none !important;
} */

.scroll-wrap {
  height: 200px !important;
  padding: 10px 12px;
  margin-top: 10px;
  overflow: hidden !important;
  border: 1px solid #ccc;
}

.cancel-btn {
  font-weight: 700;
  background-color: #fff !important;
  border: 1px solid #d5d8dc !important;
  border-radius: 6px !important;
  box-sizing: border-box !important;
  color: #363c43 !important;
}

.next-btn {
  font-weight: 700 !important;
  background-color: #087ef7 !important;
  border-radius: 6px !important;
  color: #fff !important;
}
</style>
